/* @ngInject */
class AdverseEvents {
	constructor($http) {
		this.$http = $http;
	}

	get(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/adverse-events`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesAdverseEvents(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/adverse-events/summaries/events`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getIndividualsEvents(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/adverse-events/individuals/events`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	resolveOne(eventId) {
		return this.$http.post(`${process.env.API_ENDPOINT}staff/reports/adverse-events/${eventId}/resolve`);
	}

	resolveMany(eventIds) {
		return this.$http.post(
			`${process.env.API_ENDPOINT}staff/reports/adverse-events/resolve`, {
				params: {
					events: [
						...eventIds,
					],
				},
			},
		);
	}
}

export default AdverseEvents;


// WEBPACK FOOTER //
// ./src/js/services/staff/reports/adverseEvents/index.js